import { Controller, useFormContext } from 'react-hook-form';
import { FormControlLabel, FormHelperText, MenuItem } from '@mui/material';
import { DatasetCreationEnum } from '~/api/types';
import { useGetDatasetEnumsQuery } from '~/api/v2/hooks';
import { ClearableSelect, InfoFormLabel, SelectPlaceholder } from '~/components';
import { useHasLockedStatus } from '~/hooks/dataset';

const LegalRelationshipQualifierField = () => {
  const { data, isFetching } = useGetDatasetEnumsQuery({ enumKey: DatasetCreationEnum.LEGAL_RELATIONSHIP_QUALIFIER });
  const { control, setValue } = useFormContext();
  const { hasLockedStatus } = useHasLockedStatus();

  return (
    <FormControlLabel
      label={
        <InfoFormLabel
          label="LEGAL RELATIONSHIP QUALIFIER"
          tooltipText="Optional field used to identify whether dataset is associated with a government contract. Value can be updated later if needed."
        />
      }
      control={
        <Controller
          name="legal_relationship_qualifier_tag"
          control={control}
          render={({ field, fieldState }) => (
            <>
              <FormHelperText error={!!fieldState.error}>{fieldState.error?.message as string}</FormHelperText>
              <ClearableSelect
                {...field}
                value={field.value ?? ''}
                disabled={hasLockedStatus || isFetching}
                error={!!fieldState.error}
                onClear={() => {
                  setValue('legal_relationship_qualifier_tag', null, {
                    shouldDirty: true,
                    shouldValidate: true,
                  });
                }}
                renderValue={() => {
                  if (!field.value)
                    return <SelectPlaceholder>Select the legal relationship qualifier</SelectPlaceholder>;

                  return data?.find(({ key }) => key === field.value)?.value || field.value;
                }}
              >
                {data?.map(({ value, key }) => (
                  <MenuItem key={key} value={key}>
                    {value}
                  </MenuItem>
                ))}
              </ClearableSelect>
            </>
          )}
        />
      }
    />
  );
};

export default LegalRelationshipQualifierField;
